import React, { useState, useEffect } from 'react';
import lessonCardsData from '../../../data/lessonCards.json';
import Loader from '../../Loader';
import '../../../scss/components/LessonsPage/LessonCardItem.scss';

const cardImages = {};

function importAll(r) {
    r.keys().forEach(key => {
        const fileName = key.replace('./', '');
        cardImages[fileName] = r(key);
    });
}

try {
    importAll(require.context('../../../assets/cards', false, /\.png$/));
} catch (error) {
    console.warn('Ошибка импорта изображений:', error);
}

// SVG компоненты уголков
const CornerTopLeft = () => (
    <svg className="corner corner-top-left" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 34V13.5745L13.3274 2H34" stroke="#E9F7FA" strokeWidth="4" strokeMiterlimit="10" />
    </svg>
);

const CornerTopRight = () => (
    <svg className="corner corner-top-right" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32 34V13.5745L20.6726 2H0" stroke="#E9F7FA" strokeWidth="4" strokeMiterlimit="10" />
    </svg>
);

const CornerBottomLeft = () => (
    <svg className="corner corner-bottom-left" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 0V20.4255L13.3274 32H34" stroke="#E9F7FA" strokeWidth="4" strokeMiterlimit="10" />
    </svg>
);

const CornerBottomRight = () => (
    <svg className="corner corner-bottom-right" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32 0V20.4255L20.6726 32H0" stroke="#E9F7FA" strokeWidth="4" strokeMiterlimit="10" />
    </svg>
);

const CardImage = ({ imagePath, altText }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [imageSrc, setImageSrc] = useState(null);

    useEffect(() => {
        // Сбрасываем состояние при изменении пути
        setLoading(true);
        setError(false);
        setImageSrc(null);

        // Получаем источник изображения
        const getSource = () => {
            if (!imagePath) return null;

            // Для абсолютных путей возвращаем как есть
            if (imagePath.startsWith('/')) {
                return imagePath;
            }

            // Для относительных путей извлекаем имя файла
            if (imagePath.includes('/')) {
                const fileName = imagePath.split('/').pop();
                return cardImages[fileName] || imagePath;
            }

            // Если путь не содержит слешей, предполагаем, что это уже имя файла
            return cardImages[imagePath] || imagePath;
        };

        const source = getSource();
        setImageSrc(source);
    }, [imagePath]);

    const handleImageLoad = () => {
        setLoading(false);
    };

    const handleImageError = () => {
        setLoading(false);
        setError(true);
    };

    return (
        <div className="image-container">
            <CornerTopLeft />
            <CornerTopRight />
            <CornerBottomLeft />
            <CornerBottomRight />

            {loading && (
                <div className="card-loader-container">
                    <Loader />
                </div>
            )}

            {imageSrc && (
                <img
                    src={imageSrc}
                    alt={altText}
                    onLoad={handleImageLoad}
                    onError={handleImageError}
                    className={loading ? 'loading' : ''}
                />
            )}

            {error && !loading && (
                <div className="card-error">
                    Не удалось загрузить изображение
                </div>
            )}
        </div>
    );
};

const LessonCardItem = ({ moduleName, lessonId }) => {
    const [card, setCard] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Устанавливаем состояние загрузки при изменении модуля или урока
        setLoading(true);

        // Находим карточку для текущего урока
        const foundCard = lessonCardsData.cards.find(
            c => String(c.moduleId) === String(moduleName) &&
                String(c.lessonId) === String(lessonId)
        );

        setCard(foundCard);
        setLoading(false);
    }, [moduleName, lessonId]);

    // Если карточка загружается, показываем лоадер
    if (loading) {
        return (
            <div className="lesson-card-item loading-state">
                <h3>Карточка к уроку:</h3>
                <div className="lesson-card-item-image">
                    <div className="card-loader-container">
                        <Loader />
                    </div>
                </div>
            </div>
        );
    }

    // Если карточка не найдена, не отображаем компонент
    if (!card) {
        return null;
    }

    // Проверяем наличие хотя бы одного изображения
    const hasImages = card.cardImage || card.cardImage2;
    if (!hasImages) {
        return null;
    }

    return (
        <div className="lesson-card-item">
            <h3>Карточка к уроку:</h3>

            {card.cardImage && (
                <div className="lesson-card-item-image">
                    <CardImage
                        imagePath={card.cardImage}
                        altText="Карточка к уроку"
                    />
                </div>
            )}

            {card.cardImage2 && (
                <div className="lesson-card-item-image second-image">
                    <CardImage
                        imagePath={card.cardImage2}
                        altText="Дополнительная карточка к уроку"
                    />
                </div>
            )}
        </div>
    );
};

export default LessonCardItem; 